import { useQuery } from "@tanstack/react-query";

import { api } from "@utils/api";

import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";

import { PatientSurgicalHistoryItem } from "@customTypes/patient";

import { patientQKeys } from "./queryKeys";


const select = (res: any) => {
  //   console.log(res.data);

  if (res.data.length) {
    const newData: PatientSurgicalHistoryItem[] = [];

    for (const i in res.data) {
      const { _id, date, surgery_name } = res.data[i];

      newData.push({
        id: _id,
        surgery: surgery_name,
        date: date
          ? date.split("/").length > 1
            ? new Date(
                +date.split("/")[2],
                +date.split("/")[1] - 1, // Months start from 0
                +date.split("/")[0]
              )
            : new Date(date)
          : new Date(),
      });
    }
    // console.log(newData);
    return newData.sort((a, b) => b.date.getTime() - a.date.getTime());
  }
  return null;
};

interface QueryProps {
  patientId: string;
}

export const useGetPatientSurgeries = ({ patientId }: QueryProps) => {
  const handleErrors = useQueryErrorHandling();

  return useQuery({
    queryKey: patientQKeys.surgery(patientId),
    queryFn: () => api.get(`patient/surgical/${patientId}`),
    select,

    onError: (res: any) => {
      console.error("[From Get Patient Surgeries]", res);
      handleErrors(res, "query");
    },
  });
};
